module.exports = __webpack_public_path__ + "img/2.8e11ce0a.png";